import React, {Component} from "react";
import MaterialIcon from "../MaterialIcon";
import {connect} from "react-redux";
import ExportCSV from "./ExportCSV";
import {FormattedMessage} from 'react-intl';

class EditorMenu extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "Options",
        };
        this.changeTab = this.changeTab.bind(this);
        this.updateExpression = this.updateExpression.bind(this);
        this.updateExpressionInput = this.updateExpressionInput.bind(this);
    }
    updateExpressionInput(event) {
        this.props.changeProperty(this.props.chart.id, ["expression"], [event.target.value]);
    }
    updateExpression(event, chart) {
        event.preventDefault();
        this.props.updateChart(chart);
    }
    changeTab(event) {
        this.setState({ selectedTab: event.currentTarget.dataset.id });
    }
    render() {
        let editorWrapperClass = "editor-wrapper";
        if(this.props.chart.chartSettings["editorMenuOpen"]) {
            editorWrapperClass += " open";
        }
        return (
            <div className={editorWrapperClass}>
                <div className="editor">
                    <div className="editor-header">
                        <div className="tabs">
                            <span data-id="Options" onClick={this.changeTab} className={this.state.selectedTab === "Options" ? "current" : "" }><FormattedMessage id="Options"/></span>
                            {/* <span className="disabled"><FormattedMessage id="Entities"/></span>
                            <span className="disabled"><FormattedMessage id="Metrics"/></span> */}
                            <span data-id="Expression" onClick={this.changeTab} className={this.state.selectedTab === "Expression" ? "current" : "" }><FormattedMessage id="Expression"/></span>
                            <button className="close-button"  onClick={()=>this.props.changeChartSetting(this.props.chart.id, ['editorMenuOpen'])}>
                                <MaterialIcon icon="close" size={24}/>
                            </button>
                        </div>
                    </div>
                    <div className="editor-main">
                        <div className={"editor-column " + (this.state.selectedTab === "Options" ? "active" : "")}>
                            <div className="editor-group">
                                <div className="editor-switch">
                                    <span onClick={()=> this.props.changeChartSetting(this.props.chart.id, ['active', 'editorMenuOpen']) }
                                          className={"switch-rounded " + (this.props.chart.chartSettings.active ? "ended" : "stopped")}></span>
                                    <span><FormattedMessage id="Active"/></span>
                                </div>
                                <div className="editor-switch">
                                    <span onClick={()=>this.props.changeChartSetting(this.props.chart.id, ['useCustomExpression'])}
                                          className={"switch-rounded " + (this.props.chart.chartSettings.useCustomExpression ? "ended" : "stopped")}></span>
                                    <span><FormattedMessage id="Use Custom Expression"/></span>
                                </div>
                            </div>
                            <div className="editor-group">
                                <button onClick={()=>this.props.changeChartType(this.props.chart.id, "type", 'Pie Chart')}
                                        className={"editor-button " + (this.props.chart.chartSettings.type === 'Pie Chart' ? "selected" : "")}>
                                    <MaterialIcon icon="pie_chart" size={24}/><FormattedMessage id="Pie Chart"/>
                                </button>
                                <button className="editor-button horizontal-bar disabled"><MaterialIcon icon="bar_chart" size={24}/><FormattedMessage id="Horizontal Bars"/></button>
                                <button className="editor-button disabled"><MaterialIcon icon="bar_chart" size={24}/><FormattedMessage id="Vertical Bars"/></button>
                                <button onClick={()=>this.props.changeChartType(this.props.chart.id, "type", 'Graph')}
                                        className={"editor-button " + (this.props.chart.chartSettings.type === 'Graph' ? "selected" : "")}>
                                    <MaterialIcon icon="show_chart" size={24}/><FormattedMessage id="Graph"/>
                                </button>
                                <button onClick={()=>this.props.changeChartType(this.props.chart.id, "type", 'Value')}
                                        className={"editor-button " + (this.props.chart.chartSettings.type === 'Value' ? "selected" : "")}>
                                    <MaterialIcon icon="exposure_plus_1" size={24}/><FormattedMessage id="Value"/>
                                </button>
                            </div>
                            <div className="editor-group">
                                <div className="editor-switch">
                                    <span onClick={()=> this.props.changeProperty(this.props.chart.id, ['stacked'], [!this.props.chart.stacked])}
                                          className={"switch-rounded " + (this.props.chart.stacked ? "ended" : "stopped")}></span>
                                    <span><FormattedMessage id="Stacked"/></span></div>
                            </div>
                            <div className="editor-group">
                                <button className="editor-button" onClick={()=>this.props.deleteChart(this.props.chart.id)}><MaterialIcon icon="delete" size={24}/><FormattedMessage id="Delete Panel"/></button>
                                <ExportCSV chart={this.props.chart}/>
                            </div>
                        </div>
                        <div className={"editor-column " + (this.state.selectedTab === "Expression" ? "custom-expression" : "")}>
                            <div className="editor-group bottom">
                                <span className="expression-label"><FormattedMessage id="Custom Expression"/></span>
                                <textarea className="expression-input" rows="4" cols="50" value={this.props.chart.expression} onChange={event => this.updateExpressionInput(event)}/>
                                <button className="chart-save-button" onClick={event => this.updateExpression(event, this.props.chart)} disabled={!this.props.chart.expression}><FormattedMessage id="Save"/></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        properties: state.properties
    }
}
export default connect(mapStateToProps)(EditorMenu);